import { Glasses } from "lucide-react";
import { toast } from "sonner";
import { useComfort } from "@/lib/comfort";

/** One-tap Comfort Mode switch — remembered on this device. */
export default function ComfortToggle({ testId = "comfort-toggle", withLabel = false, className = "" }) {
  const { comfort, toggle } = useComfort();
  const onClick = () => {
    const next = !comfort;
    toggle();
    toast.success(next ? "Comfort mode on" : "Comfort mode off", {
      description: next ? "Warmer colours, white text, bigger type — saved on this device." : "Back to the classic terminal look.",
      duration: 2500,
    });
  };
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={comfort}
      aria-label={comfort ? "Turn comfort mode off" : "Turn comfort mode on"}
      title={comfort ? "Comfort mode is on — tap to turn off" : "Comfort mode: warmer colours, bigger text"}
      data-testid={testId}
      data-state={comfort ? "on" : "off"}
      className={`inline-flex items-center gap-2 border transition-colors font-mono text-[11px] uppercase tracking-wider px-3 py-2.5 ${
        comfort
          ? "border-[#cfff04] bg-[#cfff04]/10 text-[#cfff04]"
          : "border-[#333] bg-[#121212] text-[#efefef] hover:border-[#cfff04] hover:text-[#cfff04]"
      } ${className}`}
    >
      <Glasses size={14} />
      {withLabel && <span>Comfort {comfort ? "on" : "off"}</span>}
    </button>
  );
}
